import ImageUploadArea from "components/ImageUploadArea";
import { LogoConfigModel, ProductConfigProps } from "models/WebShop";
import { useEffect, useState } from "react";
import { toBase64, urlToFile } from "utility/ImgUtilities";

const LogoConfig = ({ config, handleOnChange, handleFormValidation }: ProductConfigProps<LogoConfigModel>) => {


    const initialConfig = config?.[0];

    const [initialImg, setInitialImg] = useState<File | null>(null);
    const [initialized, setInitialized] = useState(false);

    useEffect(() => {
        if (!initialized && initialConfig?.publicUrlTransform) {
            async function convertImage() {
                const file = await urlToFile(initialConfig.publicUrlTransform, 'logo.png', 'image/png');
                setInitialImg(file);
                setInitialized(true);
            }
            convertImage();
        }
    }, [initialConfig, initialized]);

    const handleAdd = async (imgFile: File | null) => {
        if (imgFile !== null) {
            let encodedImg = await toBase64(imgFile as File) as string;
            let newConfig: LogoConfigModel = {
                publicUrlTransform: encodedImg,
                crmPublishLineId: initialConfig.crmPublishLineId,
                crmProductId: initialConfig.crmProductId
            }
            handleOnChange([newConfig]);
            handleFormValidation(true);
        }
        else {
            handleFormValidation(false);
        }
    }
    return <>
        <p className="text-muted">
            Endringer på kjøpte produkter vil bli behandlet fortløpende før det vises på nett.
        </p>
        <p className="text-muted mb-4">Logoen du laster opp skal være et varemerke eller grafisk symbol som representerer firmaet ditt. Den må ikke være et bilde av ansatte, personer eller fotografier, da formålet med logoen er å gi virksomheten en gjenkjennelig og profesjonell identitet.</p>
        {initialized && <ImageUploadArea onFileChange={handleAdd} initialImg={initialImg} />}
    </>
}

export default LogoConfig;